/* NIVIA MAISON — abas da grade de colecao.
   Navegacao por teclado seguindo o padrao ARIA de tablist:
   setas movem, Home/End vao aos extremos. */
(function () {
  function initSection(root) {
    root.querySelectorAll('.nm-tabs').forEach(function (section) {
      if (section.dataset.nmTabsReady) return;
      section.dataset.nmTabsReady = 'true';

      var tabs = Array.prototype.slice.call(section.querySelectorAll('.nm-tabs__tab'));
      var panels = Array.prototype.slice.call(section.querySelectorAll('.nm-tabs__panel'));
      if (tabs.length < 2) return;

      function select(index, focus) {
        tabs.forEach(function (tab, i) {
          var active = i === index;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-selected', active ? 'true' : 'false');
          tab.tabIndex = active ? 0 : -1;
          if (panels[i]) panels[i].hidden = !active;
        });
        if (focus) tabs[index].focus();
        // mantem a aba escolhida visivel quando a fila rola no celular
        var wrap = section.querySelector('.nm-tabs__nav-wrap');
        if (wrap && wrap.scrollWidth > wrap.clientWidth) {
          var tab = tabs[index];
          wrap.scrollTo({
            left: tab.offsetLeft - wrap.clientWidth / 2 + tab.clientWidth / 2,
            behavior: 'smooth',
          });
        }
      }

      tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () {
          select(i, false);
        });

        tab.addEventListener('keydown', function (event) {
          var next = null;
          if (event.key === 'ArrowRight') next = (i + 1) % tabs.length;
          else if (event.key === 'ArrowLeft') next = (i - 1 + tabs.length) % tabs.length;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = tabs.length - 1;
          if (next === null) return;
          event.preventDefault();
          select(next, true);
        });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initSection(document);
  });

  // O editor de temas recarrega a secao isolada.
  document.addEventListener('shopify:section:load', function (event) {
    initSection(event.target);
  });
})();
